import * as types from './orderActionTypes';
import {
  IOpenOrdersRequest,
  IOpenOrdersResponse,
  IOrder,
  IOrderMin
  } from './orderInterfaces';
import { OrderActionKeys as keys } from './orderActionKeys';

export const orderActionCreators = {
  fetchOpenOrders: (payload: IOpenOrdersRequest): types.FetchOpenOrders => ({
    payload,
    type: keys.FETCH_OPEN_ORDERS
  }),
  fetchOrder: (salesId: string): types.FetchOrder => ({ payload: salesId, type: keys.FETCH_ORDER }),
  fetchOrderFulfilled: (order: IOrder): types.FetchOrderFulfilled => ({
    payload: order,
    type: keys.FETCH_ORDER_FULFILLED
  }),
  fetchOrderRejected: (): types.FetchOrderRejected => ({ error: true, payload: '', type: keys.FETCH_ORDER_REJECTED }),
  setMinOrders: (payload: IOrderMin[]): types.SetMinOrders => ({ payload, type: keys.SET_MIN_ORDERS }),
  setOpenOrders: (payload: { request: IOpenOrdersRequest; response: IOpenOrdersResponse }): types.SetOpenOrders => ({
    payload,
    type: keys.SET_OPEN_ORDERS
  })
};
